// import React from "react";
// import { Fragment } from "react";
// import Head from "../../layout/Head";
// import Header from "../../Component/Shear/Header/Header";
// import Footer from "../../Component/Shear/Footer/Footer";
// import CheckoutData from "./CheckoutData";
// import CheckoutForm from "./CheckoutForm";
// import { useParams } from "react-router-dom";
// import { courses } from "../../Data/courses";

// const Checkout = () => {
//   const { slug } = useParams();

//   const courseDetails = courses.find((data) => data.slug === slug);
//   console.log(courseDetails);
//   return (
//     <Fragment>
//       <Head
//         Title="Checkout"
//         href="/checkout"
//         description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | About Pages"
//       />
//       <Header />
//       <section className="py-20 px-3 max-sm:px-10 max-xl:px-0 max-w-[1030px] mx-auto">
//         <div className="flex justify-center gap-10 max-lg:flex-row flex-col">
//           <div className="w-[50%]">
//             <CheckoutData courseDetails={courseDetails} />
//           </div>
//           <div className=" w-[50%]">
//             <CheckoutForm courseDetails={courseDetails} />
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </Fragment>
//   );
// };

// export default Checkout;
import React from "react";
import { Fragment } from "react";
import Head from "../../layout/Head";
import Header from "../../Component/Shear/Header/Header";
import Footer from "../../Component/Shear/Footer/Footer";
import { useParams } from "react-router-dom";
import { courses } from "../../Data/courses";
import { Paper } from "@mui/material";
import StepForm from "../../Component/Ui/StepForm/StepForm";
const Checkout = () => {
  const { slug } = useParams();

  const courseDetails = courses.find((data) => data.slug === slug);
  console.log(courseDetails);
  return (
    <Fragment>
      <Head
        Title="Checkout"
        href="/checkout"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | About Pages"
      />
      <Header />
      <section className="py-20 px-3 max-sm:px-10 max-xl:px-0 max-w-[1030px] mx-auto">
        <div className="flex justify-center gap-10 max-lg:flex-row flex-col">
          <Paper
            variant="outlined"
            sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
          >
            <StepForm courseDetails={courseDetails} />
          </Paper>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default Checkout;
